@use "foundation/_colors.scss";

button.reference {
  cursor: pointer;
  text-decoration: underline;
  font-size: 14px;

  &:hover {
    opacity: 0.7;
  }

  &:active {
    opacity: 0.5;
  }
}

div.documentation-reference {
  a {
    text-decoration: underline;
  }
}
